module.exports = __webpack_public_path__ + "static/media/background.fcbd7042.jpg";